import { NavBar } from "../../Components/NavBar/NavBar"
import { EditMemoriesForm } from '../../Components/EditMemoriesForm/EditMemoriesForm'

export const EditMemorie = () => {
  return (
    <div>
        <NavBar />
        <EditMemoriesForm />
    </div>
  )
}
